$('#facets-mobile-toggler').on('click tap', function() {
  console.log('toggling filters');
  $('#facets-menu').slideToggle(500);
});

$('.clear-filter').on('click tap', function() {
  const urlSegments = window.location.href.split('/');
  const currentTags = urlSegments[urlSegments.length - 1].split('+');
  const removingTags = $(this).data('tags').split('|');
  const newTags = currentTags.filter(value => !removingTags.includes(value));
  urlSegments.pop();
  const newUrl = urlSegments.join('/') + '/' + newTags.join('+');
  window.location.href = newUrl;
});